import styles from "./PPTPollsPage.module.css";
import React, {Fragment, useState} from "react";
import {
    getQuestionWeightage,
    getShortName,
    questionHasWeightage,
    removePrefix,
    removePrefixNew
} from "../../utils/helpers";
import {QRCodeCanvas} from 'qrcode.react';
import {ReactComponent as LOGO_ICON} from "../../images/yujalogo.svg"
import { ReactComponent as NoResultIllustration } from "../../images/notGradedAttendance.svg";
import {
    ALL_RESPONSES_TEXT,
    BLANK_REGEX,
    BLANK_REGEX_NEW,
    BLANK_REGEX_WRAPPED,
    BLANK_REGEX_WRAPPED_NEW, ENGAGE_SLIDE_TOP_BANNER_TEXT,
    JOIN_ENGAGE_ATTENDANCE,
    JOIN_ENGAGE_POLL,
    NO_RESPONSES_TEXT,
    POINTS_TEXT,
    POLL_SHARE_MODE,
    POLL_TYPE,
    PPT_INSTRUCTION_SLIDE_STEP_1_ATTENDANCE,
    PPT_INSTRUCTION_SLIDE_STEP_1_POLL,
    PPT_INSTRUCTION_SLIDE_STEP_2_ATTENDANCE,
    PPT_INSTRUCTION_SLIDE_STEP_2_POLL,
    PPT_INSTRUCTION_SLIDE_STEP_3,
    PPT_INSTRUCTION_SLIDE_STEP_INTRODUCTION,
    QUESTION,
    QUESTION_TYPES,
    SA_NO_RESPONSE_EXPLAIN_RELEASE_PAGE
} from "../../utils/constants";
import classes from "../ReleaseActivityPage/ReleaseActivityPage.module.css";
import presentPageClasses from "../PresentationPage/Presentation.module.css"
import {isGeneralSA, questionCodeToName} from "../../utils/questionUtils";
import ImageViewer from "../JoinQuizPage/ImageViewer";
import {LatexInline} from "../../components/Tiptap/latexParser";
import ViewLiveRespCountChart from "../ReleaseActivityPage/ViewLiveRespCountChart";
import responseClasses from "../JoinQuizPage/ClassResult.module.css";
import WordCloudResult from "../JoinQuizPage/WordCloudResult";
import ViewLiveRespRK from "../ReleaseActivityPage/ViewLiveRespRK";
import ViewLiveRespMH from "../ReleaseActivityPage/ViewLiveRespMH";
import ViewLiveRespOE from "../ReleaseActivityPage/ViewLiveRespOE";
import {useClassResultsAnalysisManager} from "../../hooks/useClassResultsAnalysisManager";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import ViewPresentAttendance from "../PresentationPage/ViewPresentAttendance";
import ViewPresentPoll from "../PresentationPage/ViewPresentPoll";
import {useConfig} from "../../hooks/useConfig";
import {Accordion} from "@base-ui/react/accordion";


export default function PPTSlides({poll, questions, shareMode, liveResponsesData}) {
    const config = useConfig();
    let {pk, sk, pollType, pollShareMode} = poll;
    let pollKey = removePrefix(pk);
    let pollCode = removePrefixNew(sk);
    pollShareMode = pollShareMode === POLL_SHARE_MODE.UNKNOWN
        ? (!!shareMode ? shareMode : POLL_SHARE_MODE.SHARE_EACH)
        : pollShareMode;

    // pollShareMode = shareMode
    //     ? (shareMode === POLL_SHARE_MODE.UNKNOWN ? POLL_SHARE_MODE.SHARE_EACH : shareMode)
    //     : (pollShareMode === POLL_SHARE_MODE.UNKNOWN ? POLL_SHARE_MODE.SHARE_EACH : pollShareMode);
    let shortName = getShortName();
    const HOST = shortName + '.' + config.host_url;
    const [pollData, ] = useState({poll, questions});

    const {responseCountData} = useClassResultsAnalysisManager(pollData , liveResponsesData);
    const {getRedirectUrl, canHavePollCode} = useSynLMSConfiguration();

    const SHARE_STATUS_ENUM = {UNSHARED: "UNSHARED", SHARING: "SHARING", SHARED: "SHARED"};




    const renderTitle = (question) => {


        if (question.questionType !== QUESTION_TYPES.FITB.name) {
            return <span><LatexInline>{question.queTitle}</LatexInline></span>;
        }
        return (
            <span className={styles.row} style={{flexWrap: "wrap"}}>
               {question.queTitle.split(question.hasBlankRestriction ? BLANK_REGEX_WRAPPED_NEW : BLANK_REGEX_WRAPPED).map((str, i) => { // /(\(.*?\))/g
                   let re = new RegExp(question.hasBlankRestriction ? BLANK_REGEX_NEW : BLANK_REGEX); // /\([^\(\)]+\)/g
                   if (!re.test(str)) {
                       const oneLine = str.replace(/[\r\n]/g, " @newLine ");
                       const wordArr = oneLine ? oneLine.split(" ") : [];
                       return (
                           <Fragment key={i}>
                               {wordArr.map((s, idx) => (
                                   <Fragment key={idx}>
                                       {s === '@newLine' &&
                                           <div style={{width: "100%"}}></div>
                                       }
                                       {!!s && s !== '@newLine' &&
                                           <div style={{marginRight: "5px"}}>{s}</div>
                                       }
                                   </Fragment>
                               ))}
                           </Fragment>
                       );
                   } else {
                       return (
                           <div className={`${presentPageClasses.FITBBox}`}>
                           </div>
                       );
                   }
               })}
           </span>
        );

    }

    let redirectUrl = getRedirectUrl(poll);
    let isPollCodeVisible = canHavePollCode(poll);

    const renderLeftPortion = () => {
        return (
            <div
                className={`${styles.canvasLeftPart} ${styles.column}`}
                style={{height: "100%", alignItems: "center", position: "relative"}}
            >
                <div style={{flex: 1}}/>
                {!!redirectUrl &&
                    <>
                        <span
                            style={{fontSize: 18, fontWeight: "700", maxWidth: "100%", textAlign: "center"}}
                        >{poll.pollTitle}</span>
                        {isPollCodeVisible &&
                            <>
                                <span className={styles.canvasJoinText}>{`Join at ${HOST}`}</span>
                                <span className={styles.pollCodeBadge}>{"Use Code: " + pollCode}</span>
                            </>
                        }


                        <div className={styles.QRCodeWrapper} style={{marginTop: 25}}>
                            <QRCodeCanvas
                                id={`QR${pollCode}`}
                                size={130}
                                renderAs="canvas"
                                value={redirectUrl}
                            />
                        </div>
                    </>
                }

                {!redirectUrl &&
                    <span style={{fontSize: 25, fontWeight: "700", maxWidth: "100%", textAlign: "center"}}>
                        {poll.pollTitle}
                    </span>
                }

                <div style={{flex: 1}}/>
            </div>
        );
    }

    const renderQuestion = (question) => {
        const {serialNo, shareCount} = question;
        const liveResponses = responseCountData[serialNo - 1];
        const isShared = !!shareCount;

        return (
            <div className={`${styles.canvas} ${styles.row}`} data-yuja-slide={`question-${serialNo}`} style={{position: "relative", paddingTop: 35}}>
                {/*left portion*/}
                {renderLeftPortion()}

                {/*right portion*/}
                <div className={styles.column} style={{flex: 1, minWidth: 0, height: "100%", padding: 20, gap: 15}}>

                    {/*first row*/}
                    <div className={styles.row} style={{gap: 15}}>
                        <span style={{fontSize: 18, fontWeight: "500", lineHeight: "22px"}}>
                            {QUESTION} {question.serialNo}
                        </span>

                        {questionHasWeightage(question) &&
                            <span
                                className={presentPageClasses.badge}
                                style={{width: "fit-content", padding: "0 10px", backgroundColor: "#E4E3F6"}}
                            >
                                {getQuestionWeightage(question)} {POINTS_TEXT}
                            </span>
                        }

                        <div className={styles.row}>
                            <span className={`${classes.thumbUpIcon} ${classes.nonHover} `} style={{marginRight: 3}}/>
                            <span style={{
                                fontSize: 15,
                                fontWeight: 500,
                                color: "#4D4D4D"
                            }}> 0 </span>
                            <div style={{width: 7}}/>
                            <span className={`${classes.thumbDownIcon} ${classes.nonHover}`} style={{marginRight: 3}}/>
                            <div style={{
                                fontSize: 15,
                                fontWeight: 500,
                                color: "#4D4D4D"
                            }}> 0
                            </div>
                        </div>
                    </div>

                    <div className={styles.row} style={{gap: 20, alignItems: "start"}}>
                        <div className={styles.column} style={{gap: 15, flex: 1}}>
                            <div className={styles.row} style={{gap: 15}}>
                                <span style={{color: "#6B6B6B"}}>
                                    {questionCodeToName(question.questionType)}
                                </span>

                                <span style={{flex: 1}}/>
                            </div>
                            {renderTitle(question)}
                        </div>
                    </div>

                    <div style={{height: 20}}/>

                    {!!question.imageURL && !question.directLinkEvp &&
                        <ImageViewer
                            width={360}
                            height={170}
                            alt={question.imageAlt}
                            imageURL={question.imageURL}
                            styles={{alignSelf: "center"}}
                        />
                    }

                    <div className={styles.column} style={{position: "relative", gap: 15}}>
                        {isShared &&
                            <span
                                style={{
                                    fontSize: 18,
                                    fontWeight: "500",
                                    width: "fit-content",
                                    position: question.questionType === QUESTION_TYPES.OE.name ? "absolute" : "unset"
                                }}
                            >{ALL_RESPONSES_TEXT}</span>
                        }


                        {!!liveResponses && (question.questionType === QUESTION_TYPES.MCSS.name
                                || question.questionType === QUESTION_TYPES.TF.name
                                || question.questionType === QUESTION_TYPES.CI.name)
                            &&
                            <ViewLiveRespCountChart
                                chartData={liveResponses}
                                showCorrectAnswer={false}
                                question={question}
                                isExpanded={true}
                                isShared={isShared}
                            />
                        }

                        {!!liveResponses
                            && isGeneralSA(question.questionType)
                            && isShared
                            &&
                            <div className={classes.column} style={{gap: 10}}>
                                {!!liveResponses && liveResponses.length > 0 && liveResponses.map((response, index) =>
                                    <div key={index} className={responseClasses.allResponseCard}>
                                        {response}
                                    </div>
                                )}

                                {(!liveResponses || !liveResponses.length) &&
                                    <>
                                        <NoResultIllustration width={130} height={71}
                                                              style={{alignSelf: "center", marginTop: 20}}/>
                                        <span style={{
                                            fontSize: 16,
                                            lineHeight: "19px",
                                            fontWeight: 600,
                                            alignSelf: "center"
                                        }}>
                                            {NO_RESPONSES_TEXT}
                                        </span>
                                        <span style={{
                                            fontSize: 14,
                                            lineHeight: "16px",
                                            fontWeight: 400,
                                            alignSelf: "center"
                                        }}>
                                            {SA_NO_RESPONSE_EXPLAIN_RELEASE_PAGE}
                                        </span>
                                    </>
                                }
                            </div>
                        }

                        {!!liveResponses
                            && question.questionType === QUESTION_TYPES.FITB.name
                            && isShared
                            &&
                            <div className={styles.column} style={{gap: 10}}>
                                {liveResponses.map((response, index) =>
                                    <div key={index} className={responseClasses.allResponseCard}>
                                        <div>
                                            {Object.keys(response).map((key, idx) =>
                                                <div key={idx}>- {response[key]}</div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {(!liveResponses || !liveResponses.length) &&
                                    <>
                                        <NoResultIllustration width={130} height={71}
                                                              style={{alignSelf: "center", marginTop: 20}}/>
                                        <span style={{
                                            fontSize: 16,
                                            lineHeight: "19px",
                                            fontWeight: 600,
                                            alignSelf: "center"
                                        }}>
                                            {NO_RESPONSES_TEXT}
                                        </span>
                                        <span style={{
                                            fontSize: 14,
                                            lineHeight: "16px",
                                            fontWeight: 400,
                                            alignSelf: "center"
                                        }}>
                                            {SA_NO_RESPONSE_EXPLAIN_RELEASE_PAGE}
                                        </span>
                                    </>
                                }
                            </div>
                        }

                        {!!liveResponses
                            && question.questionType === QUESTION_TYPES.WC.name
                            && isShared
                            &&
                            <div
                                style={{
                                    alignSelf: "center",
                                    width: "min(800px, 100%)",
                                    height: 300,
                                    backgroundColor: "#F6F6F6E6",
                                    border: "1px solid #E6E6E6",
                                    borderRadius: 4,
                                    display: "flex", alignItems: "center", justifyContent: "center"
                                }}
                            >
                                <WordCloudResult data={liveResponses}/>
                            </div>
                        }

                        {!!liveResponses && question.questionType === QUESTION_TYPES.RK.name &&
                            <ViewLiveRespRK
                                question={question}
                                chartData={liveResponses}
                                isExpanded={true}
                            />
                        }

                        {!!liveResponses && question.questionType === QUESTION_TYPES.MH.name &&
                            <Accordion.Root multiple className={classes.column} style={{gap: 10}} >
                                {question.correctAnswers.filter(i => i.length > 1).map((key, index) =>
                                    <ViewLiveRespMH
                                        key={index}
                                        correctAnswers={question.correctAnswers}
                                        premise={key[0]}
                                        premiseIdx={index}
                                        data={liveResponses[key[0]]}
                                        shouldShowCorrect={false}
                                        isShared={isShared}
                                    />
                                )}
                            </Accordion.Root>

                            // <div className={styles.column} style={{gap: 10}}>
                            //     {question.correctAnswers.filter(i => i.length > 1).map((key, index) =>
                            //         <ViewLiveRespMH
                            //             key={index}
                            //             correctAnswers={question.correctAnswers}
                            //             premise={key[0]}
                            //             premiseIdx={index}
                            //             data={liveResponses[key[0]]}
                            //             shouldShowCorrect={false}
                            //             isShared={isShared}
                            //         />
                            //     )}
                            // </div>
                        }

                        {!!liveResponses
                            && question.questionType === QUESTION_TYPES.OE.name
                            && isShared
                            &&
                            <ViewLiveRespOE originalData={liveResponses}/>
                        }
                    </div>
                </div>

                <div
                    style={{
                        position: "absolute",
                        top: 0, left: 0,
                        width: "100%", height: 35,
                        // color: "#E9F1F3",
                        background: "#E9F1F3",
                        display: "flex", alignItems: "center",
                        fontSize: 14, lineHeight: 1.6, justifyContent: "center"
                    }}
                >
                    {ENGAGE_SLIDE_TOP_BANNER_TEXT}
                </div>
            </div>
        );
    }

    const renderInstruction = () => {
        return (
            <div className={`${styles.canvas} ${styles.row}`} data-yuja-slide={"instruction"}>
                {/*left portion*/}
                {renderLeftPortion()}

                {/*right portion*/}
                <div className={styles.column}
                     style={{flex: 1, minWidth: 0, height: "100%", padding: 90, alignItems: "center"}}>
                    <span
                        className={`${styles.poweredYuJaText} ${styles.row}`}
                        style={{gap: 7, width: 'fit-content'}}
                    >
                        <LOGO_ICON style={{width: 22, height: 22}}/>
                        {"Powered by YuJa"}
                    </span>

                    <span className={styles.canvasTitle} style={{marginTop: 9}}>
                       {pollType === POLL_TYPE.ATTENDANCE
                           ? JOIN_ENGAGE_ATTENDANCE
                           : JOIN_ENGAGE_POLL
                       }
                    </span>

                    <span className={styles.canvasStepsText} style={{marginTop: 60}}>
                        {PPT_INSTRUCTION_SLIDE_STEP_INTRODUCTION}
                    </span>

                    <span className={styles.canvasStepsText} style={{marginTop: 40}}>
                        {pollType === POLL_TYPE.ATTENDANCE
                            ? PPT_INSTRUCTION_SLIDE_STEP_1_ATTENDANCE
                            : PPT_INSTRUCTION_SLIDE_STEP_1_POLL
                        }
                    </span>

                    <span className={styles.canvasStepsText} style={{marginTop: 30}}>
                         {pollType === POLL_TYPE.ATTENDANCE
                             ? PPT_INSTRUCTION_SLIDE_STEP_2_ATTENDANCE
                             : PPT_INSTRUCTION_SLIDE_STEP_2_POLL
                         }
                    </span>

                    <span className={styles.canvasStepsText} style={{marginTop: 30}}>
                        {PPT_INSTRUCTION_SLIDE_STEP_3}
                    </span>
                </div>
            </div>

        );
    }


    const renderOverAllAttendance = () => {
        return (
            <div className={`${styles.canvas} ${styles.row}`} data-yuja-slide={"instruction"}
                 style={{position: "relative", paddingTop: 35}}>
                {/*left portion*/}
                {renderLeftPortion()}

                {/*right portion*/}
                <div className={styles.column} style={{flex: 1, minWidth: 0, height: "100%", padding: 20, gap: 15}}>
                    <ViewPresentAttendance
                        pollData={pollData}
                        localState={"START POLL"}
                        setLocalState={() => {
                        }}
                        resetPollData={() => {
                        }}
                        userSettings={{}}
                    />

                </div>

                <div
                    style={{
                        position: "absolute",
                        top: 0, left: 0,
                        width: "100%", height: 35,
                        // color: "#E9F1F3",
                        background: "#E9F1F3",
                        display: "flex", alignItems: "center",
                        fontSize: 14, lineHeight: 1.6, justifyContent: "center"
                    }}
                >
                    {ENGAGE_SLIDE_TOP_BANNER_TEXT}
                </div>
            </div>

        );
    }


    const renderOverAll = () => {
        return (
            <div className={`${styles.canvas} ${styles.row}`} data-yuja-slide={"instruction"}
                 style={{position: "relative", paddingTop: 35}}>
                {/*left portion*/}
                {renderLeftPortion()}

                {/*right portion*/}
                <div className={styles.column} style={{flex: 1, minWidth: 0, height: "100%", padding: 20, gap: 15}}>
                    <ViewPresentPoll
                        pollData={pollData}
                        localState={"START POLL"}
                        setLocalState={() => {
                        }}
                        resetPollData={() => {
                        }}
                        responseCountData={[]}
                        reactionCountData={[]}
                        userSettings={{}}
                    />

                    <div
                        style={{
                            position: "absolute",
                            top: 0, left: 0,
                            width: "100%", height: 35,
                            // color: "#E9F1F3",
                            background: "#E9F1F3",
                            display: "flex", alignItems: "center",
                            fontSize: 14, lineHeight: 1.6, justifyContent: "center"
                        }}
                    >
                        {ENGAGE_SLIDE_TOP_BANNER_TEXT}
                    </div>
                </div>
            </div>

        );
    }

    return (
        <div
            className={styles.column}

        >
            {renderInstruction()}

            {pollType !== POLL_TYPE.ATTENDANCE
                && pollShareMode === POLL_SHARE_MODE.SHARE_EACH
                && questions.map((question, idx) =>
                    <Fragment key={idx}>
                        {renderQuestion(question)}
                    </Fragment>
                )
            }

            {pollType === POLL_TYPE.ATTENDANCE && renderOverAllAttendance()}
            {pollShareMode !== POLL_SHARE_MODE.SHARE_EACH && renderOverAll()}
        </div>
    );
}